import { API_STATUS } from 'core-lib/constants/network';
import { fetchAddressFromLatLng } from 'core-lib/services/fetchAddressFromLatLng';
import { getImageKitUrl } from 'core-lib/utils/imageKit';
import { useEffect, useState } from 'react';
import { fetchDealersList } from 'testDrive/services/fetchDealerList';
import { AnimatedImage, BackButton, Modal, Typography } from 'ui';
import MaterialSpinner from 'ui/components/MaterialSpinner';
import s from './DealersList.module.scss';

interface DealersListProps {
  lat: number;
  long: number;
  onSelect: (args) => void;
  onClose: () => void;
  show: boolean;
  showToast: () => void;
  isWeb?: boolean;
}

const DealersList = ({
  lat,
  long,
  onClose,
  onSelect,
  show,
  showToast,
  isWeb = false
}: DealersListProps) => {
  const [data, setData] = useState(null);
  const [apiStatus, setApiStatus] = useState(API_STATUS.default);
  const getDealerCity = async (lat, long) => {
    setApiStatus(API_STATUS.in_progress);

    const { locationData } = await fetchAddressFromLatLng({
      lat: lat,
      lng: long,
      radius: 100,
    });

    if (locationData?.city) {
      const response = await fetchDealersList(locationData.city);
      if (response) {
        setData(response);
        setApiStatus(API_STATUS.success);
      } else {
        setApiStatus(API_STATUS.failure);
        showToast();
      }
    } else {
      setApiStatus(API_STATUS.failure);
      showToast();
    }
  };

  useEffect(() => {
    if (lat && long && show) {
      getDealerCity(lat, long);
    }
  }, [lat, long, show]);

  return (
    <Modal
      show={show}
      head={{
        show: true,
        title: 'Choose your preferred dealer',
        onClose: () => onClose(),
      }}
      variant='page'
      rootStyle={{ zIndex: 3 }}
      animation={{ type: 'rtl', timeout: 'm' }}
      isWeb={isWeb}
    >
      <div className={s.root}>
        <BackButton
          type='hidden'
          onBack={() => {
            onClose();
          }}
        />
        {[API_STATUS.success].includes(apiStatus) && data?.length > 0 && (
          <div className={s.list}>
            {data?.map((item, idx) => (
              <Typography
                variant='body_para_r'
                label={item?.dealerTradeName}
                key={`${idx}^&*`}
                onClick={() => {
                  onSelect(item);
                  onClose();
                }}
              />
            ))}
          </div>
        )}
        {[API_STATUS.default, API_STATUS.in_progress].includes(apiStatus) && (
          <div className={s.loader}>
            <MaterialSpinner />
          </div>
        )}
        {[API_STATUS.failure].includes(apiStatus) && (
          <div className={s.error}>
            <AnimatedImage
              src={getImageKitUrl({
                product: 'ImageKit',
                imageUrl:
                  'https://parkplus-bkt-img.parkplus.io/production/vehicle/public/car_20230829194736577083.png',
              })}
              className={s.image}
            />
            <Typography
              variant='body_para_r'
              label={`Currently we are not serviceable \nat your location`}
              style={{ whiteSpace: 'break-spaces' }}
            />
          </div>
        )}
      </div>
    </Modal>
  );
};

export default DealersList;
